import { render, staticRenderFns } from "./dialog-selectmainfoldertemplate.vue?vue&type=template&id=7bf72b34&"
import script from "./dialog-selectmainfoldertemplate.vue?vue&type=script&lang=js&"
export * from "./dialog-selectmainfoldertemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports